import script from "./BalTableRow.vue?vue&type=script&setup=true&lang=ts"
export * from "./BalTableRow.vue?vue&type=script&setup=true&lang=ts"

import "./BalTableRow.vue?vue&type=style&index=0&id=29735e02&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-29735e02"]])

export default __exports__